//chapter1
export default {
    id : 2,//chapter number
    title : '02. 몰드 공정(Molding) (2)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/02/videos/a02.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '플라즈마 크리닝',
                '몰딩 공정',
                '몰딩 후 공정(Post Molding Curing)',
            ],
            body2 : [
                '플라즈마 크리닝에 대해 설명할 수 있다.',
                '몰딩 공정에 대해 설명할 수 있다.',
                '몰딩 후 공정에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/02/videos/02.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '트랜스퍼 몰딩을 진행한 후에는 de-gating을 진행하여 분리한다.',//html available
                    answer : "1",
                    explain : '트랜스퍼 몰딩을 진행한 후에는 de-gating을 진행하여 분리한다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '에폭시 몰딩 컴파운드가 경화되기 위해서는 몰딩 후 큐어링 공정이 필요하다. ',//html available
                    answer : "1",
                    explain : '에폭시 몰딩 컴파운드가 경화되기 위해서는 몰딩 후 큐어링 공정이 필요하다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>몰딩 공정에 따라<br>
                        1) 플라즈마 크리닝 <br>
                            - 와이어본딩이 완료된 패키지를 몰딩하기 전에 표면에 있는 불순물을 제거하는 공정     <br>
                            - PCB를 사용하는 패키지의 경우 에폭시 몰딩 컴파운드와 PCB의 접착력을 높이기 위해 진행함<br>
                        2) 몰딩 공정<br>
                            - 몰딩 방법에 따라 : 트랜스퍼 몰딩, 컴프레션 몰딩, 탑게이트 몰딩<br>
                        3) 몰딩 후 공정(Post Molding Curing)<br>
                            - 몰딩이 완료된 후 에폭시 몰딩 컴파운드를 경화시키기 위해 고온에서 일정시간 동안 경화시키는 공정</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/02/videos/a02.mp4',
        },
    ]
}